import * as d3 from 'd3';
import { AnnotationModelItem, FreeHandData } from '../interfaces';

export const drawFreehand = function (wrapper, item: AnnotationModelItem) {
  const data: FreeHandData = item.data as FreeHandData;

  const w = d3.select(wrapper);
  const freehand: d3.Selection<SVGPathElement, unknown, null, undefined> = w.select(`#item${item.id}`).node()
    ? w.select(`#item${item.id}`)
    : w.append('path');

  freehand
    .attr('id', `item${item.id}`)
    .attr('stroke', data.color)
    .attr('fill', 'none')
    .attr('stroke-width', data.strokeWidth)
    .attr('stroke-linejoin', 'round')
    .attr('stroke-linecap', 'round')
    .attr('d', data.path);
  return freehand;
};
